"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainPdfBill = mapToDomainPdfBill;
function mapToDomainPdfBill(dto) {
    return {
        id: dto.id,
        /*club: {
          id: dto.club.id || null,
          name: dto.club.name || null,
        },*/
        machine: {
            name: dto.machine.name || null,
        },
        issuer: {
            legalName: dto.issuer.legalName,
            address: dto.issuer.address,
            taxId: dto.issuer.taxId,
            phone: dto.issuer.phone,
            email: dto.issuer.email,
        },
        customer: mapToDomainCustomer(dto.customer),
        createDate: dto.createDate,
        operationId: dto.operationId,
        invoiceNumber: dto.invoiceNumber,
        orderItems: dto.orderItems,
        vatDetails: dto.vatDetails,
        totalTaxBase: dto.totalTaxBase,
        grossAmount: dto.grossAmount,
        currency: dto.currency,
        billingVerificationSystem: dto.billingVerificationSystem,
    };
}
function mapToDomainCustomer(customerDTO) {
    if (customerDTO === null)
        return null;
    return {
        name: customerDTO.name,
        address: customerDTO.address,
        taxId: customerDTO.taxId,
        phone: customerDTO.phone,
        email: customerDTO.email,
    };
}
